import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { increaseQuantity, decreaseQuantity } from '../redux/cart';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import OfferModal from './OfferModal';
import SelectAddress from './SelectAddress';
import VerificationPage from './VerificationPage';
import { toast } from 'react-toastify';

function CartPage() {
    const cartItems = useSelector(state => state.cart.items);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const totalPrice = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

    const [offers, setOffers] = useState([]);
    const [selectedOffer, setSelectedOffer] = useState({ unit: '', value: 0 });
    const [mobile, setMobile] = useState();
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        if (cartItems.length === 0) {
            toast.success("Cart is empty, redirecting...", { autoClose: 2000 });
            navigate('/'); // Redirects back
        }
    }, [cartItems, navigate]);

    // Compute discount & final price with safety clamp
    let discountRaw = 0;
    if (selectedOffer && selectedOffer.value) {
        if (selectedOffer.unit === 'Percent') {
            discountRaw = Math.round((totalPrice * selectedOffer.value) / 100);
        } else {
            discountRaw = Math.round(selectedOffer.value);
        }
    }
    const discountAmount = Math.min(totalPrice, Math.max(0, discountRaw));
    const finalPrice = totalPrice - discountAmount;

    const handleFetchOffers = async () => {
        try {
            const response = await axios.get(`${API_URL}/offerdata`);
            setOffers(response.data || []);
        } catch (err) {
            console.error("Error fetching offers:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleFetchOffers();
        setMobile(localStorage.getItem('mobile') || "");
    }, []);

    return (
        <Fragment>
            <div className='container-fluid m-t25'>
                <div className='row'>
                    <div className='col-12 cat-strip border shadow-sm'>
                        <div>
                            <button onClick={() => navigate(-1)}><IoMdArrowRoundBack /></button>
                            <label>MY CART</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                {cartItems.map(item => (
                    <div className='cart-item-card' key={item._id}>
                        <div className='cart-item-thumb'>
                            <img
                                className='cart-item-img'
                                src={`${API_URL}/${item.image1}`}
                                alt={item.name}
                                width={90}
                                height={90}
                                loading="lazy"
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = '/bestbasketlogo.png';
                                    e.currentTarget.classList.add('img-fallback');
                                }}
                            />
                        </div>
                        <div className='cart-item-info'>
                            <div className='cart-item-title'>{item.name}</div>
                            <div className='cart-item-pricing'>
                                <span className='unit-price'>₹{item.price}</span>
                                <span className='multiply'>×</span>
                                <span className='qty'>{item.quantity}</span>
                                <span className='equals'>=</span>
                                <span className='line-total'>₹{item.price * item.quantity}</span>
                            </div>
                        </div>
                        <div className='cart-item-actions'>
                            <button aria-label='Decrease quantity' onClick={() => dispatch(decreaseQuantity(item._id))}><FaMinusCircle /></button>
                            <span className='quantity-value'>{item.quantity}</span>
                            <button aria-label='Increase quantity' onClick={() => dispatch(increaseQuantity(item._id))}><FaPlusCircle /></button>
                        </div>
                    </div>
                ))}
            </div>

            <div className='offer-strip border shadow-sm z-1'>
                <label>SELECT OFFERS</label>
                <button type="button" data-bs-toggle="modal" data-bs-target="#offerModal">View All</button>
            </div>

            <div className='container-fluid mt-3'>
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <label>BILLING DETAILS</label>
                        <hr />
                        <table width="100%" aria-label="Billing summary">
                            <tbody>
                                <tr>
                                    <td>Subtotal:</td>
                                    <td style={{ textAlign: 'right' }}>₹{totalPrice}</td>
                                </tr>
                                <tr>
                                    <td>Delivery:</td>
                                    <td style={{ textAlign: 'right', color: '#1b7e32' }}>FREE</td>
                                </tr>
                                {discountAmount > 0 && (
                                    <tr>
                                        <td>Discount {selectedOffer.unit === 'Percent' ? `(${selectedOffer.value}% - ₹${discountAmount})` : ''}</td>
                                        <td style={{ textAlign: 'right', color: '#c71f23' }}>-₹{discountAmount}</td>
                                    </tr>
                                )}
                                <tr>
                                    <td colSpan="2"><hr style={{ margin: '6px 0' }} /></td>
                                </tr>
                                <tr>
                                    <td><b>Total Payable:</b></td>
                                    <td style={{ textAlign: 'right' }}><b>₹{finalPrice}</b></td>
                                </tr>
                                {discountAmount > 0 && (
                                    <tr>
                                        <td colSpan="2" style={{ fontSize: '12px', color: '#1b7e32', paddingTop: '4px' }}>
                                            You Save ₹{discountAmount}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <button className='checkout-btn' type="button" data-bs-toggle="modal" data-bs-target={mobile ? '#addressmodal' : '#loginmodal'}>
                    {mobile ? "SELECT ADDRESS" : "LOGIN TO PROCEED"}
                </button>
            </div>

            <OfferModal offers={offers} setSelectedOffer={setSelectedOffer} totalPrice={totalPrice} />
            <SelectAddress mobile={mobile} selectedAddress={(address) => navigate('/place-order', { state: { cartItems, finalPrice, address, mobile, selectedOffer } })} />
            <VerificationPage setMobile={setMobile} />
            <div className="mt-5 pt-5 pb-5 mb-5"></div>
        </Fragment>
    );
}

export default CartPage;
